import React from 'react'

import Modal from '../../../UI/Modal/Modal'
import Body from './Body/Body'
import Footer from './Footer/Footer'
import { withTranslate } from 'react-redux-multilingual'
import Spinner from '../../../UI/Spinner/Spinner'

const actionToModal = ({
  open,
  cancelled,
  submitted,
  inputChanged,
  actionToData,
  addRowClicked,
  deleteRowClicked,
  collapseClicked,
  dropdownOptions,
  currentCompany,
  translate,
  currentEmp,
  edit,
  loading
}) => {
  return (
    <Modal
      open={open}
      backdropClicked={cancelled}
      onHide={cancelled}
      header={translate('action_To')}
      size={'xl'}
      footer={<Footer saveClicked={submitted} cancelClicked={cancelled} data={actionToData} />}>
      {loading ? (
        <Spinner />
      ) : (
        <Body
          inputChanged={inputChanged}
          data={actionToData}
          addRowClicked={addRowClicked}
          deleteRowClicked={deleteRowClicked}
          collapseClicked={collapseClicked}
          dropdownOptions={dropdownOptions}
          currentCompany={currentCompany}
          currentEmp={currentEmp}
          edit={edit}
        />
      )}
    </Modal>
  )
}

export default withTranslate(actionToModal)
